/** @jsx jsx */
import React, { useState, useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import { css as cssString } from '@emotion/css';
import { Typography, Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';

import Page from 'Components/Page';
import CenteredSpinner from 'Components/CenteredSpinner';
import TokensNavbar from 'Components/TokensNavbar';
import Container from 'Components/Container';
import { AuthenticityRating } from './AuthenticityRating';
import { MainContent } from './MainContent';
import { Thumbnails } from './Thumbnails';
import { InfoArea } from './InfoArea';
import { InfoRow } from './InfoRow';
import { SocialShareButton } from 'Components/SocialShareButton';
import { MoreButton } from 'Components/MoreButton';

function Info({ tokenId, contractAddress }) {
  const theme = useTheme();
  const [tokenInfo, setTokenInfo] = useState(null);
  const [isDescriptionTruncated, setIsDescriptionTruncated] = useState(true);

  const getShortAddress = address => {
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };

  useEffect(() => {
    if (!tokenInfo) {
      const getTokenInformation = async () => {
        setTokenInfo({
          name: `Original Andy Warhol Digital Painting of Deborah Harry Original File`,
          description: ``,
          image:
            'https://firebasestorage.googleapis.com/v0/b/receiptcoin-receiptchain-de560.appspot.com/o/items%2F000000000000%2FDebbie_Harry_Andy_Warhol_Watermarked.png?alt=media&token=5abfe06c-2c08-43d6-9f14-a0073cb290bf',
          owners: [
            {
              owner: {
                user: null,
                profile_img_url: 'https://storage.googleapis.com/opensea-static/opensea-profile/1.png',
                address: '0xabab501a39e2328c23e169197f714a5216136823',
                config: '',
                discord_id: '',
              },
              quantity: '1',
            },
          ],
        });

        setTimeout(function () {
          const videoPlayer = document.getElementById('token-video');
          if (videoPlayer) {
            videoPlayer.play();
          }
        }, 1000);
      };

      getTokenInformation();
    }
  }, [contractAddress, tokenId, tokenInfo]);

  const ownerfySmartContractAddress = '0x559604845ffc64a05f780ead75249c377b1dae57';
  const digitalAndyAddress = '0x559604845ffc64a05f780ead75249c377b1dae57';

  const descriptionStyle = css`
    color: #4d5153;
    font-family: Montserrat;
    font-weight: 500;
    margin-top: 14px;
    font-size: 12px;
    letter-spacing: 0.09px;
    line-height: 27px;
    ${theme.breakpoints.up('sm')} {
      font-size: 15px;
      letter-spacing: 0.11px;
    }
  `;

  const socialShareMessage = 'Check out this NFT on Ownerfy';
  const nftPageUrl = window.location.href;

  return (
    <Page
      hasContainer={false}
      isContainerPadded={false}
      NavBarComponent={TokensNavbar}
      wrapperStyles={cssString`
        padding-bottom: 0 !important;
      `}
    >
      {tokenInfo ? (
        <div
          css={css`
            & a {
              color: #08be64;
              text-decoration: none;
            }
          `}
        >
          <div
            css={css`
              background-color: #1b1c1d;
            `}
          >
            <div
              css={css`
                border-bottom: 1px solid #313739;
                padding: 25px 0;
                ${theme.breakpoints.up('sm')} {
                  padding: 30px 0;
                }
              `}
            >
              <Container>
                <Typography
                  variant="h1"
                  css={css`
                    color: #fafafa;
                    margin: 0;
                    font-family: Avenir Next;
                    font-weight: bold;
                    font-size: 20px;
                    letter-spacing: 0.15px;
                    line-height: 27px;
                    text-align: center;
                    ${theme.breakpoints.up('sm')} {
                      font-size: 32px;
                      letter-spacing: 0.24px;
                      line-height: 44px;
                    }
                  `}
                >
                  {tokenInfo.name}
                </Typography>
              </Container>
            </div>

            <div
              css={css`
                padding: 30px 0;
                ${theme.breakpoints.up('sm')} {
                  padding: 36px 0;
                }
              `}
            >
              <Container
                isCentered
                css={css`
                  max-width: 884px;
                `}
              >
                <AuthenticityRating />
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    margin-top: 10px;
                    ${theme.breakpoints.up('sm')} {
                      margin-top: 21px;
                      flex-direction: row;
                      justify-content: space-between;
                    }
                  `}
                >
                  <MainContent animationUrl={tokenInfo.animation_url} imageSrc={tokenInfo.image} />
                  <Thumbnails />
                </div>
              </Container>
            </div>
          </div>
          <Box
            display="flex"
            flexDirection="column"
            css={css`
              ${theme.breakpoints.up('sm')} {
                flex-direction: row;
              }
            `}
          >
            <div
              css={css`
                padding: 30px 0;
                padding-top: 0;
                flex: 1;
                ${theme.breakpoints.up('sm')} {
                  padding: 50px 0;
                }
              `}
            >
              <Container
                css={css`
                  ${theme.breakpoints.up('sm')} {
                    padding: 0 44px;
                  }
                `}
              >
                <div
                  css={css`
                    max-width: 596px;
                    margin-left: auto;
                  `}
                >
                  <div
                    css={css`
                      text-align: right;
                      padding-bottom: 20px;
                      ${theme.breakpoints.up('sm')} {
                        display: none;
                      }
                    `}
                  >
                    <SocialShareButton socialShareMessage={socialShareMessage} nftPageUrl={nftPageUrl} />
                    <MoreButton />
                  </div>

                  <InfoArea title="NFT Info">
                    <InfoRow label="Token ID" info="1" />
                    <InfoRow label="Blockchain" info="Ethereum" />
                    <InfoRow
                      label="Smart Contract"
                      info={
                        <span>
                          Ownerfy{' '}
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://etherscan.io/address/${ownerfySmartContractAddress}`}
                          >
                            {getShortAddress(ownerfySmartContractAddress)}
                          </a>
                        </span>
                      }
                    />
                    <InfoRow
                      label="Owned by"
                      info={
                        <span>
                          Digital Andy NFT, LLC{' '}
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://etherscan.io/address/${digitalAndyAddress}`}
                          >
                            {getShortAddress(digitalAndyAddress)}
                          </a>
                        </span>
                      }
                    />
                    <InfoRow
                      label="Created by"
                      info={
                        <span>
                          Digital Andy NFT, LLC{' '}
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://etherscan.io/address/${digitalAndyAddress}`}
                          >
                            {getShortAddress(digitalAndyAddress)}
                          </a>
                        </span>
                      }
                    />
                    <InfoRow label="Created" info="Apr 13, 2021" />
                  </InfoArea>

                  <InfoArea
                    title="Unlockable Content"
                    css={css`
                      margin-top: 30px;
                    `}
                  >
                    <InfoRow label="Original Image" info="320 x 240 px, PNG (141 kb)" />
                    <InfoRow label="Original Video" info="MP4" />
                  </InfoArea>

                  <Typography
                    variant="h3"
                    css={css`
                      margin-top: 40px;
                      color: #4d5153;
                      font-weight: 500;
                      font-family: Montserrat;
                      font-size: 18px;
                      letter-spacing: 0.14px;
                      line-height: 32px;
                      text-align: center;
                    `}
                  >
                    This NFT is currently listed for sale by
                    <br />
                    <strong>TBD Auction House</strong>
                    <a
                      href="#"
                      css={css`
                        display: block;
                        height: 55px;
                        width: 263px;
                        background-color: #1b1c1d;
                        color: #ffffff !important;
                        font-family: Work Sans;
                        font-size: 14px;
                        font-weight: bold;
                        letter-spacing: 0.11px;
                        line-height: 55px;
                        text-align: center;
                        margin: 22px auto 0 auto;
                        text-transform: uppercase;
                        text-decoration: none;
                        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                        &:hover {
                          background-color: #343638;
                        }
                      `}
                    >
                      View Auction
                    </a>
                  </Typography>
                </div>
              </Container>
            </div>

            <div
              css={css`
                padding: 20px 0;
                padding-top: 60px;
                flex: 1;
                background-color: #fafafa;
                border-left: 1px solid #d8d8d8;
                ${theme.breakpoints.up('sm')} {
                  padding: 50px 0;
                  padding-top: 15px;
                }
              `}
            >
              <Container
                css={css`
                  padding-top: 0;
                  padding-bottom: 0;
                  ${theme.breakpoints.up('sm')} {
                    padding: 0 44px;
                  }
                `}
              >
                <div
                  css={css`
                    max-width: 596px;
                    margin-right: auto;
                  `}
                >
                  <div
                    css={css`
                      text-align: right;
                      padding-bottom: 20px;
                      display: none;
                      ${theme.breakpoints.up('sm')} {
                        padding-bottom: 0;
                        display: block;
                      }
                    `}
                  >
                    <SocialShareButton socialShareMessage={socialShareMessage} nftPageUrl={nftPageUrl} />
                    <MoreButton />
                  </div>
                  <InfoArea title="Description" hasSeparator={false}>
                    <div
                      css={css`
                        overflow: hidden;
                        height: ${isDescriptionTruncated ? '400px' : 'auto'};
                        ${theme.breakpoints.up('sm')} {
                          height: ${isDescriptionTruncated ? '870px' : 'auto'};
                        }
                      `}
                    >
                      <Typography variant="body1" css={descriptionStyle}>
                        Andy Warhol is, undoubtedly, one of the most iconic innovators of the pop art genre. Andy is
                        known for his Polaroid and Xerox based images with creative use of bold, solid colors. Beyond
                        his designs featuring iconic products and logos, Andy’s portraits are easily recognized for his
                        unique creativity and distinctive style.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Andy’s cutting-edge work and A-list celebrity status attracted Commodore International to engage
                        him to demonstrate the graphic capabilities of their new Amiga 1000 computer at a launch event.
                        On June 14, 1985, Andy met with Commodore executives at their corporate offices in the Seagram’s
                        building in New York City. Andy described Commodore’s Amiga computer as a “machine that’s like
                        the Apple thing but can do a hundred times more.” Andy was fascinated by the Amiga’s color
                        display. As a result of the meeting, Andy was subsequently commissioned to appear at the Amiga
                        computer launch event and use the device to create a piece of artwork.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Having just five weeks until the Amiga launch event, Andy, a computer neophyte, needed a crash
                        course in how to use the computer and graphic software that was still in a precarious prototype
                        state. To meet that need Commodore staggered two of their artist/engineers, Jack (from Amiga’s
                        California facility) and Jeff (from Commodore’s Pennsylvania facility), to be onsite at Andy’s
                        studio to bring him up to speed on the capabilities and limitations of the Amiga graphics
                        program. Over the weeks, Andy took frequent interruptions from his other projects and
                        commitments to build his confidence and grow his understanding of what he could achieve.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Jeff was unfamiliar and unaware of the fame of Andy. In fact, some of Jeff’s coworkers from
                        Commodore’s Pennsylvania offices were envious of his opportunity. When Jeff asked, “Who is this
                        guy?” a coworker answered, “He’s the artist that did the Campbell’s soup cans!” Unimpressed,
                        Jeff thought that he meant that Andy had designed the actual labels for the soup cans on grocery
                        store shelves. It was only over subsequent sessions at Andy’s studio and conversations with
                        others that Jeff came to appreciate Andy’s relevance and importance in the art world.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        As the event date approached, Andy became nervous. In fact, on July 23, 1985, in his diary he
                        described his feelings as, “The day started off with dread as I woke up from my dreams and
                        thought about my live appearance and how nothing is worth all this worrying, to wake up and feel
                        so terrified.”
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Warhol had asked his good friend and Blondie frontwoman, Debbie Harry, to model for the portrait
                        he was going to create. She arrived early for the rehearsal at New York’s beautiful Lincoln
                        Center, while Warhol arrived on schedule at 9:00 am. Jeff was on-hand to help with any technical
                        issues, while Jack was sitting by Andy’s side to assist with the use of the software. Andy and
                        Debbie ran through their part, which was recorded by press. Andy and Debbie showed their
                        interest in the technology by asking questions about the capabilities of the Amiga. During the
                        run through, Andy showed his comfort with the software drawing tools, even if his understanding
                        of the technical process was lacking. Andy directed Debbie and the cameraman to get his desired
                        digital pose. He then, with clear intentions, chose colors and paint tools to create the digital
                        portrait of Debbie. Andy even reflected on the process in his diary: “We ran through it, and the
                        easiest part is running through our thing for the press, that’s so easy.” This rehearsal session
                        was recorded, and is available for review.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Following the press opportunity, the Amiga computer was to be prepared and reset by Jeff for the
                        live event scheduled for later that evening. Jeff was about to turn off the Amiga that Andy had
                        just used. The digital portrait that Andy created of Debbie Harry would have been lost forever,
                        if not for the quick thinking of Jeff to save it to disk. But realizing that the image was of a
                        famous musician, Jeff decided to save the image to a diskette. It should be noted that the Amiga
                        did not have a hard drive at that time and only supported 3.5” diskettes to save files. Jeff
                        located Andy and attempted to give Andy the disk containing the portrait. Andy was disinterested
                        and told Jeff, “You can keep it.” Jeff asked Andy to sign the disk, which Andy obliged and
                        handed it back to Jeff saying “Here, it’s yours.” At the time, Jeff didn’t fully appreciate the
                        gift he had been given.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Andy and Debbie returned at 5:30pm for the evening Commodore Amiga launch event that would
                        include the pop artist and his model creating a portrait live for the packed house audience.
                        Jeff launched the paint program and stepped away so that Andy could recreate his portrait of
                        Debbie. Jack joined Andy to engage him with commentary and explain to the audience what Andy was
                        doing. Debbie acknowledges she hammed it up some for the cameras, turning toward Andy, running
                        her hand through her hair, and asking in a suggestive Marilyn voice, "Are you ready to paint
                        me?"
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Unfortunately, the recreation of Debbie’s portrait did not go as well during the live event. Due
                        to stage lighting that was different than during rehearsal, the image captured of Debbie did not
                        have good contrast areas that would lend well to filling with color. Nonetheless, Andy worked
                        through the performance demonstrating the graphic software. In fact, Andy’s lack of appreciation
                        for the result is reflected in his diary where he wrote, “the drawing came out terrible and I
                        called it ‘a masterpiece.’ It was a real mess.”
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Debbie reflects that, “It was a pretty amazing event.” Contrary to Andy’s dismissive attitude
                        towards the Debbie portrait, it has been described by others as a “cultural artifact” and “a
                        work of art befitting Warhol’s name.” The following paragraph from OpenCulture.com sums up the
                        historical importance best:
                      </Typography>
                      <Typography
                        variant="body1"
                        css={css`
                          ${descriptionStyle}
                          font-style: italic;
                        `}
                      >
                        “Say what you will about mid-eighties American culture, but how many historical moments could
                        bring together a world-famous visual artist and rock star over a genuinely innovative consumer
                        product? Maybe Apple could orchestrate something similar today; after all, we endure no drought
                        of celebrity enthusiasm for iPods, iPads, iMacs, and iPhones. But could they come up with
                        participants to match the iconic gravity of Andy Warhol and Debbie Harry? … Both of them arrive
                        at the 1985 launch of the Commodore Amiga, and the silver-wigged one sits down to demonstrate
                        the personal computer’s then-unparalleled graphical power by “painting” the Blondie frontwoman’s
                        portrait. He tints it blue, clicks some red paint bucket here, clicks some yellow paint bucket
                        there, and before we know it, we’re gazing upon a Warholian image ready for admiration…”
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        In the months following the Amiga launch event, Jeff was invited back to Andy’s studio to assist
                        with the creation of Amiga computer graphics for the first episode of “Andy Warhol’s Fifteen
                        Minutes” television show for MTV.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Andy dabbled a bit with the Amiga to create a small assortment of computer artwork. But few of
                        these pieces were made public. A rare interview opportunity was given to Guy Wright and Glenn
                        Soukko of Amigaworld magazine. Jeff was on hand to assist Andy create some digital images while
                        being interviewed. Again, Jeff thought to save these images for posterity and to provide the
                        magazine visual context to include in their article. Some of the images appeared in the January
                        1986 magazine article “Andy Warhol: An Artist and His Amiga.”
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Unfortunately, Andy passed away just nineteen months after creating his portrait of Debbie, in
                        February 1987.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        In 1999, Jeff contacted the Warhol Foundation in an attempt to authenticate the digital portrait
                        of Debbie that Andy had created and saved to the signed diskette. The Foundation refused to do
                        so. Their explanation was multifaceted. First, they claimed that the digital portrait was not
                        acknowledged as one of Andy’s works in his portfolio. Second, they took the position that the
                        signed diskette was nothing more than an autographed memento.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        In 2002, Jeff made another attempt to pursue bringing the unique portrait to the world. He
                        contacted Vincent Freemont, Andy’s former Vice President of Andy Warhol Enterprises and then an
                        executive with the Warhol Foundation, to seek his advice and opinion. Again, Jeff’s efforts were
                        rebuffed, even though Vincent recalled Jeff’s involvement at the time.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        For years, those that handled Andy’s affairs after his death took no interest in Andy’s digital
                        portrait.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        Since 1985, Jeff has kept the diskettes with the files of Debbie and those from the Amigaworld
                        interview, safe for posterity. In 2014, a team at Carnegie Melon University assisted The Warhol
                        Foundation in accessing some additional images from diskettes that had been filed away amongst
                        Andy’ property since his death. It should be noted that the now famous Debbie Harry portrait was
                        unsurprisingly not mentioned to be amongst the files that were recovered. The Warhol Museum
                        describes the images they recovered as Andy’s computer “experiments.” However, Andy had
                        described them as “sketches” in a 1985 interview. In fact, Warhol’s contract with Commodore back
                        in 1985 even specified that only hard-copy versions of his work would be considered art (see,
                        e.g., www.warhol.org/hacking-vintage-technology-to-simulate-time-travel). But society has come
                        to recognize them as more.
                      </Typography>
                      <Typography variant="body1" css={descriptionStyle}>
                        The meaning of “art” has changed over time with advances in technology and the evolution of
                        interests and perspectives of admirers and collectors. While nobody may have realized it at the
                        time, Andy’s bridging the traditional art medium with the technical spontaneity of computers all
                        demonstrated before a live audience was groundbreaking. Andy’s digital portrait of Debbie Harry
                        represents that very occasion and the digital file that Jeff saved captured that moment. We
                        typically think of art as fixed in time and space. Andy, intentionally or not, created this
                        image represented by an NFT and brought art to an entirely different dimension, which is as art
                        should be. This image might be the earliest file minted as an NFT and literally sits at the
                        crossroads of life before computers and the digitalized version it has become since. This is
                        likely the most provenanced Warhol NFT and, equally important, the only one there will ever be.
                      </Typography>
                    </div>
                    <Typography
                      variant="body1"
                      css={css`
                        font-style: italic;
                        background-color: #fafafa;
                        text-align: right;
                        font-family: Bitter;
                        color: #939798;
                        cursor: pointer;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 27px;
                        letter-spacing: 0.09px;
                        width: 100%;
                        margin-top: 7px;
                        display: ${isDescriptionTruncated ? 'inline-block' : 'none'};
                        ${theme.breakpoints.up('sm')} {
                          font-size: 15px;
                          letter-spacing: 0.11px;
                          margin-top: 10px;
                        }
                      `}
                      onClick={() => setIsDescriptionTruncated(false)}
                    >
                      ... Read more
                    </Typography>
                  </InfoArea>
                </div>
              </Container>
            </div>
          </Box>
        </div>
      ) : (
        <CenteredSpinner />
      )}
    </Page>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    tokenId: ownProps.match.params.tokenId,
    contractAddress: ownProps.match.params.contractAddress,
  };
}

export default withRouter(connect(mapStateToProps, null)(Info));
